export default {
    props: {
        collapsed: Boolean,
        collapsedSize: String,
        collapsible: Boolean,
        contentUrl: String,
        max: String,
        min: String,
        resizable: Boolean,
        scrollable: Boolean,
        size: String
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/PaneProps.js